module.exports = __webpack_public_path__ + "media/images/lb/147-2130e3ff84246b6e0e80c8f90a91a65e.svg";